module.exports = __webpack_public_path__ + "img/menu-fold.49c8be9a.svg";